export default {
  tags: {
    handle: '标签操作',
    closeall: '关闭所有',
    closeother: '关闭其他'
  },
  route: {
    dashboard: '异常卡数量统计',
    widget: '控件',
    permission: '权限控制',
    datatable: '表格',
    components: '组件',
    cityDetail: '地市详情',
    singleCard: '单卡异常卡查询',
    page1: '组件1',
    page2: '组件2',
    page3: '组件3',
    profile: '个人中心',
    panels: '卡片展示'
  },
  app: {
    switchlang: '切换语言成功',
    unlock: '解锁'
  },
  login: {
    edenPart1: 'VUE',
    edenPart2: 'EDEN',
    title: '系统登录',
    btn: '登录',
    radioEN: '英语',
    radioZH: '中文',
    forgetpwd: '忘记密码',
    remember: '记住我',
    userplaceholder: '请输入您的手机号码',
    pwdplaceholder: '请输入短信验证码',
    valid: {
      userexist: '请输入正确的手机号码！',
      pwdexist: '验证码错误！'
    },
    forget_email: '请输入邮箱',
    forget_code: '请输入验证码',
    forget_passwrd: '请输入新密码',
    confirm_passwrd: '请输入确认密码',
    forget_btn: '重置',
    forget_back: '返回',
    validfaild: '登陆校验未通过，是不是哪里出问题了？',
    pwdChanged: '密码重置成功！'
  },
  sidebarDropDown: {
    profile: '个人中心',
    lock: '锁定系统',
    logout: '退出登录'
  },
  msg: {
    msg1: '你有一条来自管理员的新消息。',
    msg2: '查看本周伊甸园系统的监控汇报。',
    msg3: '伊甸园有一些新的升级，来一起看看吧。'
  },
  dashboard: {
    sr: '系统报告',
    pch: '占比统计',
    todo: '待办事项'
  },
  lock: {
    locked: '系统已被锁定！',
    unlock: '系统已解锁成功！'
  }
}
